import { CuUssdApiRequest } from '@/services/cu-ussd-api.request';
import { IPushBulkRequeueBody, IPushMarkPushedBody, IPushRequeueBody } from '@/types/types';

export class DownstreamPushService {
  static fetchTransactions(query?: string) {
    return CuUssdApiRequest().get(`/downstream-push${query || ''}`);
  }

  static requeue(adminId: string, transactionId: string, body: IPushRequeueBody) {
    return CuUssdApiRequest().post(`/downstream-push/${transactionId}/requeue`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }

  static bulkRequeue(adminId: string, body: IPushBulkRequeueBody) {
    return CuUssdApiRequest().post(`/downstream-push/requeue`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }

  static markPushed(adminId: string, transactionId: string, body: IPushMarkPushedBody) {
    return CuUssdApiRequest().post(`/downstream-push/${transactionId}/mark-pushed`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }
}
